import React, { useEffect, useState } from "react";
import {
  getNumberWithUnit,
  VideoIframe,
  VideoModal,
  FundInnerDetails,
} from "@hedgefund/shared";
import 'react-responsive-modal/styles.css';
import { Row, Col, Drawer, Avatar } from "antd";
import {
  Button,
  Spinner,
  CardWithLable,
  Table,
  // Input,
} from "@public/ui-toolkit";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import {
  getMyFundDetail,
  uploadTearSheet,
  getInvestorList,
  updateMonthlyReturn,
  // uploadFileDeck,
  getPerformanceMetricsSearchResult,
  GetRiskReportSearchResult,
  RiskReportSearchResultByMonth,
  getFundBioUsersAction,
} from "./actions";
import Stats from "@hedgefund/shared/src/Stats";
import FundRiskReport from "@hedgefund/shared/src/FundRiskReport";
import FundTearSheet from "@hedgefund/shared/src/FundTearSheet";

const investorColumns = [
  {
    name: "Comapny Name",
    key: "companyName",
  },
  {
    name: "Documents Count",
    key: "documents",
  },
];
const statusEnum = [
  {
    name: "Pending",
    key: 0,
  },
  {
    name: "Processing",
    key: 1,
  },
  {
    name: "Published",
    key: 2,
  },
  {
    name: "Close",
    key: 3,
  },
  {
    name: "Rejected",
    key: 4,
  },
  {
    name: "Restricted",
    key: 5,
  },
];

const FundDetail = ({ match, location }) => {
  const [hide, setHide] = useState(false);
  const [fundOverview, setFundOverview] = useState(false);
  const [fundBio, setFundBio] = useState(false);

  const history = useHistory();

  const hedgeFundId = match.params.id;
  const fundUrlId = match.params.fundId;
  const id = fundUrlId !== undefined ? fundUrlId : hedgeFundId;

  const fundDetailState = useSelector((state) => state.fundDetail);
  const dispatch = useDispatch();

  const {
    myFundDetails,
    monthlyReturnPerformance,
    riskReportMonthList,
    reportExtractData,
    investorList,
    loading,
    tearSheetLoading,
    pmLoading,
    performanceMetrcisMonth,
    tableLoading,
    // fileDeckLoading,
    fundBioUsers,
    bioLoading,
  } = fundDetailState;

  useEffect(() => {
    dispatch(getMyFundDetail(id));
    dispatch(getInvestorList(id));
  }, []);


  useEffect(() => {
    if (id) {
      dispatch(GetRiskReportSearchResult({ id: id }));
    }
  }, []);


  const handleYearChange = (presentYear) => {
    dispatch(getPerformanceMetricsSearchResult({ id: id, year: presentYear }));
  };


  const handleReportChange = (report) => {
    dispatch(RiskReportSearchResultByMonth(report));
  };
  // const onSuccessAlert = () => {
  //   alertService.success("Successfully uploaded!", { autoClose: true });
  // };

  // const formik = useFormik({
  //   initialValues: {
  //     file: "",
  //     recordId: "",
  //     docType : "",
  //   },
  //   validationSchema: Yup.object({
  //     docType: Yup.string().required("Document Type is required"),
  //     file: Yup.string().required("File Deck is required"),
  //   }),
  //   onSubmit: (values) => {
  //     const formData = new FormData();
  //     formData.append(`Url`, values.file);
  //     formData.append(`RecordId`, myFundDetails?.id);
  //     formData.append(`DocType`, values.docType)
  //     uploadFundDeck(formData);
  //   },
  // });
  // const uploadFundDeck = (values) => {
  //   dispatch(uploadFileDeck(values, onSuccessAlert, onCloseModal));
  // };
  return (
    <main>
      <div className="main-inner">
        <div className="mt-4">
          {loading || !Object.keys(myFundDetails)?.length ? (
            <Spinner />
          ) : (
            <>
              <Row gutter={16} style={{ margin: "auto" }}>
                <Col span={6} className="gutter-row ml-4" style={{ backgroundColor: "#fff", borderRadius: "10px" }}>
                  <div className="position-fixed" style={{ width: "25%" }}>
                    <Row>
                      <Col span={24}>
                        <img
                          src={
                            myFundDetails?.hedgeFund?.logo
                              ? myFundDetails?.hedgeFund?.logo
                              : "/assets/images/bg1.png"
                          }
                          className="logo-style"
                          alt="..."
                        />
                        {/* <Col span={24}>
                      <img className="hedge-Fund-Card" src={myFundDetails?.hedgeFund?.logo ? myFundDetails?.hedgeFund?.logo : "/assets/images/bg1.png"} alt="Profile Image" />
                    </Col> */}
                      </Col>
                      <Col>
                        <Col span={24} className="text-center mt-3">
                          <div className="Fund-FontSize" style={{ fontSize: "26px" }}>{myFundDetails?.hedgeFund?.name} </div>
                          <h4 className="ml-4" style={{ width: "85%" }}>{myFundDetails?.hedgeFund?.address}</h4>
                        </Col>
                        <Col span={6} offset={9} style={{ marginTop: "10px" }}>
                          <Button
                            btnName="Investors"
                            btnType="primary"
                            onClick={() => {
                              setHide(!hide);
                            }}
                          />
                        </Col>
                        <Col span={24}>
                          <hr style={{ fontSize: "5px", marginLeft: "15px", marginRight: "15px" }} />
                          <FundInnerDetails
                            img={myFundDetails?.hedgeFund?.logo}
                            officeLocation={myFundDetails?.hedgeFund?.address}
                            strategyValue={myFundDetails?.strategyName}
                            subSpecialities={myFundDetails?.subSpecialtyName}
                            aumValue={`${getNumberWithUnit(
                              myFundDetails?.hedgeFund?.aum
                            )}`}
                            ytdValue={`${myFundDetails?.ytd}%`}
                            annualReturnsValue={`${myFundDetails?.annualizedReturn}%`}
                            annualVolatilityValue={`${myFundDetails?.annualVolatility}%`}
                            companyName={myFundDetails?.hedgeFund?.name}
                            ytd={false}
                          />
                        </Col>
                        <hr style={{ fontSize: "5px", marginLeft: "15px", marginRight: "15px" }} />
                        <Col span={23} offset={1} style={{ marginTop: "10px" }}>
                          <Stats
                            ytdValue={id === window._env_.EthosFundId ? `${myFundDetails?.monthlyReturnPerformances[0]?.ytd.toFixed(2)}%*` : `${myFundDetails?.monthlyReturnPerformances[0]?.ytd.toFixed(2)}%`}
                            latestMonthValue={`${myFundDetails?.monthlyReturn}%`}
                            annualReturnsValue={id === window._env_.EthosFundId ? `` : `${myFundDetails?.annualizedReturn}%`}
                            annualVolatilityValue={id === window._env_.EthosFundId ? `` : `${myFundDetails?.annualVolatility}%`}
                          />
                        </Col>

                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col span={17} className="gutter-row">
                  <Row>
                    <Col className="mb-3" span={24} style={{ backgroundColor: "#fff", padding: "20px 10px", position: "relative", borderRadius: "10px", }}>
                      <Row style={{ justifyContent: "end" }}>

                        <Button
                          btnName={"Fund Overview"}
                          iconClass="fa fa-pencil-square-o mr-1"
                          btnType="primary"
                          onClick={() => {
                            setFundOverview(!fundOverview);
                          }}
                        />
                        <Button
                          btnName={"Fund Bios"}
                          iconClass="fa fa-pencil-square-o mr-1"
                          btnType="primary"
                          onClick={() => {
                            dispatch(getFundBioUsersAction(myFundDetails?.hedgeFund?.id));
                            setFundBio(true);
                          }}
                        />
                        <Button
                          btnName={"Cloud Document"}
                          iconClass="fa fa-cloud mr-1"
                          btnType="primary"
                          onClick={() => history.push(`/cloud-document/${myFundDetails?.hedgeFund?.id}`)}
                        />
                      </Row>
                    </Col>

                    {myFundDetails?.note !== null ? (
                      <Col span={24}>
                        <div className="sticky">
                          <h5>Additional Information : </h5>
                          <p>{myFundDetails?.note}</p>
                        </div>
                      </Col>
                    ) : ""}
                    {fundOverview && (
                      <Col span={24} className={`sticky expandable ${fundOverview}-animation mb-3`}>
                        <h5>{"Fund Overview"} : </h5>
                        <p dangerouslySetInnerHTML={{ __html: myFundDetails?.description ? myFundDetails?.description : "N/A" }} />
                      </Col>
                    )}
                    {myFundDetails?.status !== 2 && (
                      <Col span={24} className="mb-3" style={{ backgroundColor: "#fff", padding: "20px", overflowX: "scroll", borderRadius: "10px" }}>
                        <div className="text-center d-flex m-auto justify-content-center">
                          <div
                            className="alert alert-primary text-center w-75"
                            role="alert"
                          >
                            <p>
                              Fund is in{" "}
                              <b>{statusEnum[myFundDetails?.status].name + " "}</b>
                              State!
                            </p>
                            {myFundDetails?.status === 4 && (
                              <span>
                                <u>FCN Note</u> : {myFundDetails?.adminNote}
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    )}
                    <Col span={24}>
                      {myFundDetails?.status === 2 && (
                        <>
                          {
                            <div className={`expandable ${hide}-animation`}>
                              <div
                                className="
                    d-flex
                    flex-wrap
                    justify-content-between
                    align-items-center
                  "
                              >
                                <div className="mr-3">
                                  <div className="mb-0 Fund-FontSize" style={{ fontSize: "26px" }}> Investors</div>
                                </div>
                              </div>

                              <div>
                                <CardWithLable title={"Invested Funds"}>
                                  <div className="hf-card2-body px-0 pb-0">
                                    <div className="hf-table">
                                      <Table
                                        columns={investorColumns}
                                        NoFound={"No Invested Fund Found"}
                                        data={investorList}
                                        onRowClick={(row) =>
                                          history.push(`/document/${row.id}`)
                                        }
                                      />
                                    </div>
                                  </div>
                                </CardWithLable>
                              </div>
                            </div>
                          }
                        </>
                      )}
                    </Col>
                  </Row>
                  <Row className={hide ? "mt-3" : ""} style={{ backgroundColor: "#fff", padding: "12px 20px", borderRadius: "10px" }}>
                    <Col span={24}>
                      <div className="mb-0 Fund-FontSize" style={{ fontSize: "26px" }}>{myFundDetails?.name} Media</div>
                      <Col className="rounded bg-white p-1 mt-3">
                        <VideoModal myFundDetails={myFundDetails} />
                      </Col>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ backgroundColor: "#276598", padding: "12px 20px", borderRadius: "4px" }} className="mt-4">
                      <div className="Fund-FontSize" style={{ color: "#fff", margin: "0px" }}>Fund: {myFundDetails?.name} {" "}
                        <span className="Fund-FontSize">{`(${statusEnum[myFundDetails?.status]?.name})`}</span></div>
                    </Col>
                    <FundTearSheet
                      fundId={id}
                      fund={myFundDetails}
                      portal={"hedgefund"}
                      handleYearChange={handleYearChange}
                      getPerformanceMetricsSearchResult={getPerformanceMetricsSearchResult}
                      performanceMetrcisMonth={performanceMetrcisMonth}
                      monthlyReturnPerformance={monthlyReturnPerformance}
                      loading={loading}
                      tearSheetLoading={tearSheetLoading}
                      uploadTearSheet={uploadTearSheet}
                      updateMonthlyReturn={updateMonthlyReturn}
                      tableLoading={tableLoading}
                    />
                    <Col span={24}>
                      <FundRiskReport
                        fundId={id}
                        fund={myFundDetails}
                        portal={"hedgefund"}
                        reportExtractData={reportExtractData}
                        riskReportMonthList={riskReportMonthList}
                        handleReportChange={handleReportChange}
                        pmLoading={pmLoading}
                      />
                    </Col>
                  </Row>
                  {/* <Row className="border mt-3"
                    style={{
                      minHeight: "300px",
                      background: "#ffff",
                      padding: "10px",
                      borderRadius: "10px",
                      width: "100%",
                    }}>
                    <Col span={19} >
                      <div className="Fund-FontSize" style={{ fontSize: "26px" }}>{myFundDetails?.name} Fund Document Cloud</div>
                    </Col>
                    <Col span={5} >
                      <Row style={{ justifyContent: "end" }}>
                        <Button
                          btnName="Upload Pdf"
                          btnType="!primary"
                          iconClass="fa fa-download mr-2"
                          onClick={onOpenModal}
                          type="button"
                        />
                        <ReactModal open={open} onClose={onCloseModal} center title={"Upload File Deck"} >
                          <form onSubmit={formik.handleSubmit}>
                            <div className="modal-body">
                              <Row gutter={[12,12]}>
                              <Col span={24}>
                                    <Select
                                      styles={customStyles}
                                      defaultValue={"Select Document Type"}
                                      onChange={(e) => {
                                        formik.setFieldValue("docType", e.value)
                                      }}
                                      options={CloudDocuments.map((item) => {
                                        return {
                                          value: item?.key,
                                          label: item?.name,
                                        };
                                      })}
                                    />
                                    {formik.touched.docType &&
                                      formik.errors.docType ? (
                                      <div className="form-error-message">
                                        {formik.errors.docType}
                                      </div>
                                    ) : null}
                                  </Col>
                                <Col span={24}>
                                  <Input
                                    type="file"
                                    id="file"
                                    name="file"
                                    onChange={(e) =>
                                      formik.setFieldValue("file", e.target.files[0])
                                    }
                                    accept=".pdf"
                                  />
                                  {formik.touched.file &&
                                    formik.errors.file ? (
                                    <div className="form-error-message">
                                      {formik.errors.file}
                                    </div>
                                  ) : null}
                                </Col>
                              </Row>
                            </div>
                            <div className="modal-footer d-block text-center">
                              <Button
                                btnName="Upload"
                                btnType="primary"
                                loading={fileDeckLoading}
                                type="submit"
                              />
                            </div>
                          </form>
                        </ReactModal>
                      </Row>
                    </Col>
                    <Col span={24} >
                      <FundDeck
                        decks={myFundDetails?.decks}
                      />
                    </Col>
                  </Row> */}
                </Col>
              </Row>
              <VideoIframe myFundDetails={myFundDetails} />
            </>
          )}
        </div>
        <Drawer title="Fund Bio's" open={fundBio} onClose={() => setFundBio(false)} width={500}  >
          <Row>
            <Col span={24} className="mt-2 bg-light">
              {!bioLoading ? (
                fundBioUsers?.map((user) => {
                  return (
                    <Row style={{ margin: "5px 0px", borderLeft: "3px solid #9f9f9f" }}>
                      <Col span={4} className="text-center">
                        <Avatar src={user?.profileImage} style={{ height: "50px", width: '50px' }} size={"large"} />
                      </Col>
                      <Col span={19} >
                        <Row>
                          <Col span={24} >
                            <span className="font-weight-bold"> {user?.fullName} </span>
                          </Col>
                          <span className="text-secondary" style={{ fontSize: "11px" }}> {user?.title}</span>

                          <Col span={24}>
                            <p dangerouslySetInnerHTML={{ __html: user?.highlight ? user?.highlight : "N/A" }} />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  )
                })
              ) : (
                <Spinner />
              )}
            </Col>
          </Row>
        </Drawer>
      </div>
    </main >
  );
};

export default FundDetail;
